[
  {
    "code": "LY-AJ",
    "name": "Ajdabiya"
  },
  {
    "code": "LY-BU",
    "name": "Al Butnan"
  },
  {
    "code": "LY-JA",
    "name": "Al Jabal al Akhdar"
  },
  {
    "code": "LY-JI",
    "name": "Al Jifarah"
  },
  {
    "code": "LY-JU",
    "name": "Al Jufrah"
  },
  {
    "code": "LY-KF",
    "name": "Al Kufrah"
  },
  {
    "code": "LY-MJ",
    "name": "Al Marj"
  },
  {
    "code": "LY-MB",
    "name": "Al Marqab"
  },
  {
    "code": "LY-QT",
    "name": "Al Qatrun"
  },
  {
    "code": "LY-QB",
    "name": "Al Qubbah"
  },
  {
    "code": "LY-WA",
    "name": "Al Wahah"
  },
  {
    "code": "LY-HZ",
    "name": "Al hizam al Akhdar"
  },
  {
    "code": "LY-NQ",
    "name": "An Nuqat al Khams"
  },
  {
    "code": "LY-SH",
    "name": "Ash Shati'"
  },
  {
    "code": "LY-ZA",
    "name": "Az Zawiyah"
  },
  {
    "code": "LY-BA",
    "name": "Banghazi"
  },
  {
    "code": "LY-BW",
    "name": "Bani Walid"
  },
  {
    "code": "LY-DR",
    "name": "Darnah"
  },
  {
    "code": "LY-GD",
    "name": "Ghadamis"
  },
  {
    "code": "LY-GR",
    "name": "Gharyan"
  },
  {
    "code": "LY-GT",
    "name": "Ghat"
  },
  {
    "code": "LY-JB",
    "name": "Jaghbub"
  },
  {
    "code": "LY-MI",
    "name": "Misratah"
  },
  {
    "code": "LY-MZ",
    "name": "Mizdah"
  },
  {
    "code": "LY-MQ",
    "name": "Murzuq"
  },
  {
    "code": "LY-NL",
    "name": "Nalut"
  },
  {
    "code": "LY-SB",
    "name": "Sabha"
  },
  {
    "code": "LY-SS",
    "name": "Sabratah Surman"
  },
  {
    "code": "LY-SR",
    "name": "Surt"
  },
  {
    "code": "LY-TN",
    "name": "Tajura wa al Nawahi AlArba'"
  },
  {
    "code": "LY-TB",
    "name": "Tarabulus"
  },
  {
    "code": "LY-TM",
    "name": "Tarhunah-Masallatah"
  },
  {
    "code": "LY-WD",
    "name": "Wadi al Hayat"
  },
  {
    "code": "LY-YJ",
    "name": "Yafran-Jadu"
  }
]